import { useAuth } from 'fennec-ui';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function Block(props) {
    const { title, background, style, children } = props;
    const auth = useAuth();
    return (<div style={{display:"flex", flexDirection:"column", ...style}}>
        {title && <div style={{ fontSize: "16px", padding: "6px", display: "flex", justifyContent: "space-between" }}>
            <div className='block-title' >{title}</div>
        </div>}
        <div className="bg bg-grey" style={{ /*minHeight: "240px",*/ backgroundColor: background, flex: "auto" }}>
            {children}
        </div>
    </div>)
}